module.exports = __webpack_public_path__ + "static/preamp-241cb1b19726464548a115b22248de50.jpg";